import { GuidancePrepPaneV3 } from '@/features/guidance/v3'
import type { YakurekiDetail } from '@/shared/types/yakurekiCore'

interface Props {
  event: YakurekiDetail
}

// latest の指導前準備は V3 固定 (= apps/latest shell は新スタックを含意する).
export const GuidancePrepPane = ({ event }: Props) => (
  <GuidancePrepPaneV3 event={event} />
)
